export const GET_TEMPLATE_TYPE_LIST_CREATE = 'GET_TEMPLATE_TYPE_LIST_CREATE';
export const GET_REBATE_PROGRAM = 'GET_REBATE_PROGRAM';
export const GET_MANUFACTURER_DATA = 'GET_MANUFACTURER_DATA';
export const GET_QUARTER_VALUE = 'GET_QUARTER_VALUE';
export const SEARCH_REQUEST_TAB = 'SEARCH_REQUEST_TAB';
export const GET_ERROR_MSG_CREATE_LETTER = 'GET_ERROR_MSG_CREATE_LETTER';
export const GET_TEMPLATE_NAME_LIST = 'GET_TEMPLATE_NAME_LIST';
export const GET_PRINT_PREVIEW_CREATE = 'GET_PRINT_PREVIEW_CREATE';
export const GET_PRINT_PREVIEW_CONTENT = 'GET_PRINT_PREVIEW_CONTENT';
export const GET_PREVIEW_DRAFT_PDF_CREATE = 'GET_PREVIEW_DRAFT_PDF_CREATE';
export const GET_DETAIL_DATA = 'GET_DETAIL_DATA';
export const GET_TO_MAIL_ID_CREATE = 'GET_TO_MAIL_ID_CREATE';
export const GET_FROM_MAIL_ID_CREATE = 'GET_FROM_MAIL_ID_CREATE';
export const GET_CREATE_TEMPLATE_EXTRA_STATE =
  'GET_CREATE_TEMPLATE_EXTRA_STATE';
export const FETCH_CREATE_LETTER_DETAIL_CREATE =
  'FETCH_CREATE_LETTER_DETAIL_CREATE';
export const FETCH_CREATE_LETTER_DETAIL_DATA_CREATE =
  'FETCH_CREATE_LETTER_DETAIL_DATA_CREATE';
export const SAVE_CREATE_LETTER_DATA_CREATE = 'SAVE_CREATE_LETTER_DATA_CREATE';
export const GET_INVOICE_DETAILS_BY_INVOICE_NUM_CREATE =
  'GET_INVOICE_DETAILS_BY_INVOICE_NUM_CREATE';
export const GET_INVOICE_DETAILS_BY_INVOICE_NUM_BEFOR_CREATE =
  'GET_INVOICE_DETAILS_BY_INVOICE_NUM_BEFOR_CREATE';
export const SEND_LETTER_BY_EMAIL_CREATE = 'SEND_LETTER_BY_EMAIL_CREATE';
export const CREATE_LETTER_CLEAR_REDUX_DATA = 'CREATE_LETTER_CLEAR_REDUX_DATA';
